export enum ERoutes {
  ABOUT = 'about',
  APPS = 'apps',
  APPS_IOS = 'open-nettest-for-ios',
  APPS_ANDROID = 'open-nettest-for-android',
  APPS_WINDOWS = 'open-nettest-for-windows',
  APPS_MACOS = 'open-nettest-for-macos',
  APPS_LINUX = 'open-nettest-for-linux',
  APPS_WEB = 'open-nettest-for-web',
  APPS_CLI = 'open-nettest-for-cli',
  ARTICLES = 'articles',
  COOKIE_POLICY = 'cookie-policy',
  DATA = 'data',
  HELP = 'help',
  MAP = 'map',
  METHODOLOGY = 'methodology',
  MUNICIPALITY = 'municipality/:name',
  OPEN_DATA = 'open-data',
  PRIVACY_POLICY = 'privacy-policy',
  SOLUTIONS = 'solutions',
  SOLUTIONS_OVERVIEW = 'overview',
  SOLUTIONS_CROWD = 'crowdsourcing-applications',
  SOLUTIONS_WEB = 'web-portal',
  SOLUTIONS_REGULATORY = 'regulatory-portal',
  SOLUTIONS_DASHBOARDS = 'dashboards',
  SOLUTIONS_AUTO = 'automated-measurements',
  STATISTICS = 'statistics',
  TERMS_OF_SERVICE = 'terms-of-use',
  TEST = 'internet-speed-test',
  TEST_PROGRESS = 'progress',
  TEST_HISTORY = 'history',
  TEST_HYSTORY_RESULTS = 'results/:id',
  PAGE_NOT_FOUND = 'page-not-found',
  WIZARD = 'wizard',
  CONTACT = 'contact',
}
